import React from 'react'
import { PropTypes } from 'prop-types'

import { getDomainStatus } from 'organisms/EmailSetting/utils'

export const DomainStatusBadge = ({ valid, lastValidationAttemptAt }) => {
  const status = getDomainStatus(valid, lastValidationAttemptAt)
  if (status === 'validated') {
    return (
      <span className="text-green flex items-center gap-1">
        <i className="fas fa-check icon" />
        Validated
      </span>
    )
  }
  if (status === 'failed') {
    return (
      <span className="text-red flex items-center gap-1">
        <i className="icon fas fa-xmark" />
        Failed
      </span>
    )
  }
  return (
    <span className="text-orange flex items-center gap-1">
      <i className="far fa-exclamation-triangle icon" />
      Pending
    </span>
  )
}

DomainStatusBadge.propTypes = {
  valid: PropTypes.bool,
  lastValidationAttemptAt: PropTypes.number,
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/DomainRow/index.js